import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus' //全局引入
import 'element-plus/dist/index.css'
import './style.css'
import './assets/fonts.css'

createApp(App).use(ElementPlus).use(router).mount('#app') 